"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.merge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cnf = {};
var languageConfigs = document.getElementById('language-configs');
cnf.i18n = {
  ns: ['translation', 'datamaster-farm-detail-view'],
  defaultNS: 'translation',
  fallbackLng: false,
  saveMissing: false,
  nsSeparator: ':::',
  keySeparator: '::',
  detection: {
    order: ['htmlTag']
  },
  react: {
    wait: false,
    bindI18n: 'languageChanged loaded',
    bindStore: 'added removed',
    nsMode: 'default'
  },
  backend: {
    loadPath: '/static/locales/{{lng}}/{{ns}}.json',
    addPath: '/debug/locales/add/{{lng}}/{{ns}}'
  }
};

if (languageConfigs && languageConfigs.getAttribute('data-key')) {
  cnf.i18n = (0, _lodash.default)(cnf.i18n, JSON.parse(languageConfigs.getAttribute('data-key')));
}

var _default = cnf;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/i18n/conf/conf.js
// module id = 662
// module chunks = 0